export const MONTH_NAMES = [
    "month-l-1", "month-l-2", "month-l-3", "month-l-4", "month-l-5", "month-l-6",
    "month-l-7", "month-l-8", "month-l-9", "month-l-10", "month-l-11", "month-l-12"
];

const SHORT_DAY_NAMES = ["day-s-1", "day-s-2", "day-s-3", "day-s-4", "day-s-5", "day-s-6", "day-s-7"];

export const CARDINAL_NAMES = ["first-s", "second-s", "third-s", "fourth-s", "fifth-s"];

export type PickType = 'd' | 'm' | 'y' | 't' | 'h' | 'mi';

export type ViewType = 'day' | 'week' | 'month' | 'year';

export interface Day {
    dt: Date;
    work: boolean;
    out: boolean;
    sel: boolean;
    today: boolean;
    hidden?: boolean;
}

// function isLeapYear(dt: Date): boolean {
//     const year = dt.getFullYear();
//     return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
// }

function treatAsUTC(date: Date) {
    const result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
}

export function daysBetween(startDate: Date, endDate: Date) {
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const res = (treatAsUTC(endDate).getTime() - treatAsUTC(startDate).getTime()) / millisecondsPerDay;
    return res;
}

export function endOfDay(dt: Date){
    const endOfDay = new Date(dt);
    endOfDay.setHours(23,59,59,999);
    return endOfDay;
}

function isWorkDay(dt: Date): boolean {
    const dow = dt.getDay();
    return dow !== 0 && dow !== 6;
}

export function shortDayNames(isMondayFirst: boolean){
    if(isMondayFirst){
        return SHORT_DAY_NAMES
    }
    return [SHORT_DAY_NAMES[6], ... SHORT_DAY_NAMES.slice(0,6)]
}

export function truncToHour(dt: Date): Date {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes());
}

export function trunc(dt: Date): Date {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
}

export function getDay(refDate: Date, isMondayFirst: boolean) {
    let day = refDate.getDay();
    if(isMondayFirst){
        day--;
        if (day < 0) {
            day = 6;
        }
    }
    return day;
}

export function calendarRows(refDate: Date, selected: Date, isMondayFirst = true): Day[][] {
    const month = refDate.getMonth();   // Base 0
    let hh = 0, mm = 0;
    if (selected) {
        hh = selected.getHours();
        mm = selected.getMinutes();
    }

    let dt = new Date(refDate.getFullYear(), month, 1, hh, mm);
    const day = getDay(dt, isMondayFirst);

    const truncatedToday = trunc(new Date());
    const truncatedSelectedTime = selected ? trunc(selected).getTime() : -1;
    const from = new Date(dt);
    from.setDate(dt.getDate() - day);

    const rows: Day[][] = [];
    let row: Day[];

    dt = from;
    for (let week = 0; week < 6; week++) {
        row = [];
        for (let d = 0; d < 7; d++) {
            row.push({
                dt,
                work: isWorkDay(dt),
                out: dt.getMonth() !== month,
                sel: trunc(dt).getTime() === truncatedSelectedTime,
                today: trunc(dt).getTime() === truncatedToday.getTime(),
            })
            dt = new Date(dt);
            dt.setDate(dt.getDate() + 1);
        }
        rows.push(row);
    }

    return rows;
}


export function calendarWeek(refDate: Date, isMondayFirst: boolean) {
    const truncatedToday = trunc(new Date());

    const day = getDay(refDate, isMondayFirst);

    const from = new Date(refDate);
    from.setDate(from.getDate() - day);

    let dt = from;

    const row: Day[] = [];

    for (let d = 0; d < 7; d++) {
        row.push({
            dt,
            work: isWorkDay(dt),
            out: false,
            sel: false,
            today: trunc(dt).getTime() === truncatedToday.getTime(),
        })
        dt = new Date(dt);
        dt.setDate(dt.getDate() + 1);
    }

    return row;
}
